<div fxLayout="row wrap" fxLayoutGap="15px grid" class="margin conteudo-list" fxLayoutGap.lt-md="5px grid"
    fxLayoutAlign="center center">
    <!--
  5px grid
<div *ngIf="page > 1">
<fa-icon class="pointer" [icon]="['fas', 'arrow-left']" [classes]="['size-15x']" (click)="previous()"></fa-icon>
</div>
-->
    <div fxFlex="32" *ngFor="let article of articles" class="conteudo-height" fxLayoutGap="10px"
        style="background-color:white; margin-bottom:5px;">
        <div fxLayout="column" style="height: 100%;" fxLayoutAlign.lt-md="space-between">
            <div fxLayout="column" fxLayoutGap="10px" fxLayoutGap.lt-md="6px">
                <div fxLayout="column" fxLayoutGap="35px" fxLayoutGap.lt-md="10px">
                    <img class="image imageHeight"
                        src="{{ article.pathImgListagem ? storageUrl + article.pathImgListagem : storageUrl + article.pathImagem }}">
                    <span class="data margin">{{article.dataInclusao | date: 'dd/MM/yyyy'}}</span>
                </div>
                <div fxLayout="column" fxLayoutGap="10px" class="margin">
                    <a class="title title-font-size truncate-2 pointer" href="/articles/read-article/{{article.id}}"
                        routerLink="/articles/read-article/{{article.id}}">
                        {{article.titulo}}
                    </a>
                    <span class="description truncate-4">
                        {{article.resumo}}
                    </span>
                </div>
            </div>
            <div class="margin" fxLayout="column" fxLayoutGap="35px" fxLayoutGap.lt-xl="25px" class="footer">

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="54px" fxLayoutGap.lt-md="5px" class="author">
                    <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center"
                        fxLayoutAlign.lt-md="start center">
                        <img class="author-img" src="./assets/icons/icon_user.svg">
                        <span *ngIf="article.autor" class="truncate-1">{{article.autor.nome}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="center center"
                        fxLayoutAlign.lt-md="start center">
                        <img src="./assets/icons/icon_quote.svg">
                        <span>{{article.totalComentarios}}</span>
                    </div>
                </div>

                <app-button
                    [href]="'./articles/read-article/' + article.id" fxHide.gt-sm [txt]="'LER ARTIGO'"
                    [btnClass]="'btn-darkblue-filled conteudo-a-vista-btn-w'" [fontFamily]="'Oswald'"></app-button>
                <app-button fxHide.lt-md
                    [href]="'./articles/read-article/' + article.id" [txt]="'LER ARTIGO COMPLETO'"
                    [btnClass]="'btn-darkblue-filled conteudo-a-vista-btn-w'" [fontFamily]="'Oswald'"></app-button>



            </div>
        </div>
    </div>
    <!--
 <div *ngIf="page < totalPages || totalPages === null">
  <fa-icon class="pointer" [icon]="['fas', 'arrow-right']" [classes]="['size-15x']" (click)="next()"></fa-icon>
</div>
-->
</div>

<div fxLayout="row" fxLayoutAlign="center center" style="margin-top:50px" *ngIf="showPaginate">
    <app-pagination [paginateConfig]="paginateConfig" (setCurrentPageEmitter)="getData($event)"></app-pagination>
</div>